<div class="container">
  <div class="row justify-content-center mt-2">
    <div class="mx-auto">
      <img src="/content/images/brand/ipdj.png" alt="IPDJ" style="height: 100px" />
    </div>
  </div>
  <div class="row justify-content-center mt-2">
    <div class="col">
      <h2>Olá</h2>
      <p *ngIf="!hasStorageInstitution()">
        Está a aceder à plataforma como <b>{{ account?.firstName }} {{ account?.lastName }}</b>
      </p>
      <p *ngIf="hasStorageInstitution()">
        Está a aceder à plataforma como <b>{{ institution?.designation }}</b>
      </p>
    </div>
  </div>
  <div class="mt-2 row" *ngIf="hasStorageInstitution()">
    <div class="col">
      <p>
        Para sair da instituição ativa, carregue
        <b>
          <a (click)="selectInstitution()">aqui!</a>
        </b>
      </p>
    </div>
  </div>
  <div class="mt-2 row" *ngIf="(personInstitutions?.length || 0) > 0">
    <div class="col">
      <p>
        Se pretender representar uma instituição, e assim candidatar essa instituição a um dos programas do IPDJ, I.P., selecione em baixo a
        instituição a representar
      </p>
    </div>
  </div>

  <div class="mt-2 row row-cols-2" *ngIf="(personInstitutions?.length || 0) > 0">
    <div class="col" *ngFor="let record of personInstitutions; trackBy: trackId">
      <div
        class="card card-stats shadow mb-3"
        *ngIf="record.institution?.institutionStatus === InstitutionStatus.APPROVED"
        (click)="selectInstitution(record.institution)"
        [ngClass]="{ 'border-success': record.institution?.id === institution?.id }"
      >
        <div class="card-body m-2">
          <div class="row">
            <div class="col">
              <h5 class="card-title text-uppercase text-muted mb-0">{{ record.institution?.designation }}</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <hr />
  <div class="mt-2 row row-cols-2">
    <p>Programas disponíveis</p>
  </div>
  <div class="mt-2 row row-cols-2">
    <ng-container *ngFor="let menu of menus">
      <div
        class="col"
        *ngIf="
          menu.type == MenuType.SIMPLE &&
          ((menu.profile === MenuProfile.INSTITUTION && hasStorageInstitution()) ||
            (menu.profile === MenuProfile.YOUNG && !hasStorageInstitution()) ||
            getMenuProgram(menu) === null)
        "
      >
        <div class="card card-stats shadow mb-3" (click)="goTo(menu.path)">
          <div class="card-body m-2">
            <div class="row">
              <div class="col">
                <h5 class="card-title text-uppercase text-muted mb-0" [innerHTML]="menu.title | translate"></h5>
              </div>
              <div class="col-auto">
                <div class="icon icon-shape rounded-circle shadow">
                  <ng-container [ngSwitch]="getMenuProgram(menu)">
                    <span *ngSwitchCase="ProgramEnum.AGORA_NOS" class="yth-AGORA_NOS"></span>
                    <span *ngSwitchCase="ProgramEnum.SOUDIGITAL" class="yth-AGORA_NOS"></span>
                    <span *ngSwitchCase="ProgramEnum.NAVEGAS" class="yth-AGORA_NOS"></span>
                    <span *ngSwitchCase="ProgramEnum.CTI" class="yth-CTI"></span>
                    <span *ngSwitchCase="ProgramEnum.CUIDA_TE" class="yth-CUIDA_TE"></span>
                    <span *ngSwitchCase="ProgramEnum.EQUALITY" class="yth-EQUALITY"></span>
                    <span *ngSwitchCase="ProgramEnum.EJA" class="yth-EJA"></span>
                    <span *ngSwitchCase="ProgramEnum.EUROSCOLA" class="yth-EUROSCOLA"></span>
                    <span *ngSwitchCase="ProgramEnum.FERIAS" class="yth-FERIAS"></span>
                    <span *ngSwitchCase="ProgramEnum.FLORESTAS" class="yth-FLORESTAS"></span>
                    <span *ngSwitchCase="ProgramEnum.GERACAOZ" class="yth-GERACAOZ"></span>
                    <span *ngSwitchCase="ProgramEnum.AFIRMATE" class="yth-AFIRMATE mr-2"></span>
                    <span *ngSwitchCase="ProgramEnum.EMPREENDEJA" class="yth-EMPREENDEJA mr-2"></span>
                    <span *ngSwitchCase="ProgramEnum.SETENTAJA" class="yth-SETENTAJA mr-2"></span>
                    <span *ngSwitchCase="ProgramEnum.NAMORAR" class="yth-NAMORAR mr-2"></span>
                    <span *ngSwitchCase="ProgramEnum.OTL" class="yth-OTL"></span>
                    <span *ngSwitchCase="ProgramEnum.PASSE_JOVEM" class="yth-PASSE_JOVEM"></span>
                    <span *ngSwitchCase="ProgramEnum.WORKCAMP_REGISTRATION" class="yth-WORKCAMP_REGISTRATION"></span>
                    <ng-container *ngSwitchDefault>
                      <fa-icon *ngIf="menu.icon" [fixedWidth]="true" [icon]="menu.icon"></fa-icon>
                    </ng-container>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
